export default class TabsMobile {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        $('.tabs-secondary .tabs_content_all').each(function (i, e) {
            let defaultVal = $(this).find('.tabs_list_item:first-child p').text();
            $('<div class="tabs_content_mobile"><span>' + defaultVal + '</span></div>').prependTo($(this));
        });

        $('body').on('click', '.tabs-secondary .tabs_list_item', function (e) {
            let current = $(this).find('p').text();
            $(this).parents('.tabs_content_all').find('.tabs_content_mobile span').html(current);
            $(this).parents('.tabs_content_all').find('.tabs_list_container').removeClass('open');
        });

        $('body').on('click', '.tabs-secondary .tabs_content_mobile span', function (e) {
            let parent = $(this).parents('.tabs_content_all').find('.tabs_list_container');
            parent.hasClass('open') ? parent.removeClass('open') : parent.addClass('open');
            $(this).parents('.tabs_content_mobile').toggleClass('open');
        });
    }
}